<template>
  <div class="flex flex-col">
    <div class="flex items-center gap-[10px]">
      <input
        :id="id"
        type="radio"
        :value="value"
        :name="name"
        class="custom-radio"
        v-model="internalModel"
        :disabled="disabled"
      />

      <div class="flex flex-col items-start gap-[6px]">
        <label
          :for="id"
          :class="[
            customLabel ? customLabel : 'BodyS',
            { 'text-[#DFDCDD] pointer-events-none': disabled },
          ]"
        >
          {{ label }}
        </label>
        <!-- quantity selector -->
        <div
          v-if="quantitySelector"
          class="relative flex items-center gap-[6px]"
        >
          <!-- ปุ่มลบ -->
          <ButtonComponent
            :icon="'MinusIcon'"
            :bClass="'btn_shadow--2 !w-[42px] !h-[42px] !min-w-[42px] !min-h-[42px]'"
            :disabled="isInactive || localFieldValue <= minValue"
            @clicked="decrement"
          />
          <!-- input number -->
          <input
            type="number"
            v-model="localFieldValue"
            @input="updateFieldValue($event.target.value)"
            @keydown="allowOnlyNumbers"
            class="w-full h-[42px] px-[10px] rounded-[4px] border-[1px] border-solid PC_Body1-R text-center outline-none no-spinner"
            :class="
              isInactive
                ? 'border-[#DFDCDD] text-[#DFDCDD] bg-[#F3F2F2]'
                : 'border-[#B7B2B5] text-[#1F1D1F] bg-[#fff]'
            "
            :readonly="isInactive"
            :min="minValue"
            :max="maxValue"
          />
          <!-- ปุ่มบวก -->
          <ButtonComponent
            v-if="maxValue"
            :icon="'AddIcon'"
            :bClass="'btn_shadow--2 !w-[42px] !h-[42px] !min-w-[42px] !min-h-[42px]'"
            :disabled="isInactive || localFieldValue >= maxValue"
            @clicked="increment"
          />
          <ButtonComponent
            v-else
            :icon="'AddIcon'"
            :bClass="'btn_shadow--2 !w-[42px] !h-[42px] !min-w-[42px] !min-h-[42px]'"
            :disabled="isInactive"
            @clicked="increment"
          />
        </div>
        <!-- quantity selector -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, nextTick } from "vue";

const props = defineProps({
  id: { type: String, required: true },
  name: { type: String, required: true },
  value: { type: [String, Number], required: true },
  label: { type: String, required: true },
  modelValue: { type: [String, Number], default: "" },
  fieldValue: { type: [String, Number], default: "" },
  minValue: { type: [String, Number], default: 0 },
  maxValue: { type: [String, Number], default: "" },
  customLabel: { type: String, required: false },
  disabled: { type: Boolean, default: false },
  quantitySelector: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue", "update:fieldValue"]);

const localFieldValue = ref("");
const isInitialized = ref(false);
const inputWidth = ref(20);
const sizer = ref(0);

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal === props.value) {
      localFieldValue.value = props.fieldValue;
    }
  }
);

const internalModel = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

const isInactive = computed(() => internalModel.value !== props.value);

onMounted(() => {
  // if (props.fieldValue !== undefined && props.modelValue === props.value) {
  //   localFieldValue.value = props.fieldValue;
  // }
  if (props.fieldValue !== undefined) {
    localFieldValue.value = props.fieldValue;
  }
});

const initializeFieldValue = () => {
  if (props.fieldValue && props.modelValue === props.value) {
    localFieldValue.value = props.fieldValue;
  }
  isInitialized.value = true;
};

// const updateFieldValue = (val) => {
//   if (localFieldValue.value !== val) {
//     localFieldValue.value = val;
//     emit("update:fieldValue", localFieldValue.value);
//   }
// };
const updateFieldValue = (val) => {
  // if (localFieldValue.value !== val) {
  let num = parseFloat(val || "0");

  if (num < props.minValue) num = props.minValue;
  if (props.maxValue != "" && num > props.maxValue) num = props.maxValue;

  localFieldValue.value = num;
  emit("update:fieldValue", num);
  // }
};

const allowOnlyNumbers = (e) => {
  const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"];

  if (allowedKeys.includes(e.key) || (e.key >= "0" && e.key <= "9")) {
    return;
  }

  e.preventDefault();
};

const decrement = () => {
  if (props.modelValue === props.value) {
    const num = parseInt(localFieldValue.value || "0", 10);
    const newVal = num - 1;
    localFieldValue.value = newVal;
    emit("update:fieldValue", newVal);
  }
};

const increment = () => {
  if (props.modelValue === props.value) {
    const num = parseInt(localFieldValue.value || "0", 10);
    const newVal = num + 1;
    localFieldValue.value = newVal;
    emit("update:fieldValue", newVal);
  }
};

initializeFieldValue();
</script>
  
<style lang="scss" scoped>
.radio-field {
  transition: all 0.3s ease;
}

.radio-field.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.custom-radio {
  appearance: none;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border: 1px solid #8d8d8d;
  border-radius: 50%;
  cursor: pointer;
  background-color: white;
}

.custom-radio:disabled {
  border: 1px solid #dfdcdd;
  pointer-events: none;
}

.custom-radio:checked {
  border: 5px solid #9b237b !important;
}

.custom-radio:hover {
  background-color: #f5f5f5;
}

.custom-radio:focus {
  outline: none;
}

.custom-radio:checked + label {
  color: #5d5c57;
}

/* สำหรับ Chrome, Safari, Edge, Opera */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* สำหรับ Firefox */
.no-spinner[type="number"] {
  -moz-appearance: textfield;
}

.BodyS {
  color: #1f1d1f;

  /* Body/s */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}
</style>
  